const STORAGE_DATA = {
  SELECTED_COMPANY: 'selected-company',
  SELECTED_PROJECT: 'selected-project',
  SELECTED_PROJECT_NAME: 'selected-project-name',
  FILTERED_OFFICE_TYPES: 'filtered-office-types',
};

export default STORAGE_DATA;
